module.exports = __webpack_public_path__ + "img/logo.111a869c.png";